import ECSAttributionObject from './_ecs-attribution-object-class.js'
import ECSLeadUtils from './_ecs-attribution-parameters.js'

export default class ECSEntrataAttribution {
  testParamsForLeads (_provider, _params) {
    const search = window.location.search

    if (!search.includes('switch_cls')) {
      return false
    }

    const idRegex = /switch_cls([^=]*)=/
    const valueRegex = /switch_cls.*?=([^&]+)/
    const leadId = search.match(idRegex)[1]
    const leadValue = search.match(valueRegex)[1]

    const lead = {
      active: true,
      id: leadId,
      value: leadValue,
      provider: _provider,
      string: 'switch_cls' + leadId + '=' + leadValue
    }

    return lead
  }

  filterLeads (_settings, _leadParams, _source) {
    if (_source.result == undefined) {
      return false
    }

    let sourceData = false
    const leadSources = _source.result.property[_settings.propertyId].leadSources.leadSource
    for (let i = 0; i < leadSources.length; i++) {
      if (leadSources[i].attributes.id == _leadParams.value) {
        sourceData = leadSources[i].attributes
      }
    }

    return sourceData
  }

  // Parse the API return and build an object containing replacement values for
  // attribution elements on the front end
  buildAttribution (_settings, _leadParams, _apiReturn) {
    const filtered = this.filterLeads(_settings, _leadParams, _apiReturn)
    if (!filtered) {
      console.warn('Entrata returned leads list does not include lead parameter.')
      return false
    }

    const leadAttribution = new ECSAttributionObject(
      _settings.leadProvider,
      filtered.name,
      filtered.vanityNumber,
      filtered.id,
      _leadParams.id,
      _leadParams.value
    )

    return leadAttribution
  }

  // Builds an object of data that matches the required input for the sendLead PHP function
  buildSendLeadsData (_data, _leadId) {
    const request = {
      customer: {},
      request: {},
      leadId: _leadId
    }

    for (const [key, value] of Object.entries(_data)) {
      const cleanKey = key.toLowerCase().replace('-', '').replace('_', '').replace(' ', '')

      switch (cleanKey) {
        case 'name': case 'fullname':
          const nameSplit = value.split(' ')
          request['customer']['first_name'] = nameSplit[0]
          request['customer']['last_name'] = nameSplit[1]
          break
        case 'first': case 'firstname':
          request['customer']['first_name'] = value
          break
        case 'last': case 'lastname': case 'surname':
          request['customer']['last_name'] = value
          break
        case 'email':
          request['customer']['email'] = value
          break
        case 'phone': case 'phonenumber': case 'number':
          request['customer']['phone'] = value
          break
        case 'address': case 'streetaddress': case 'street':
          const addressSplit = value.replace('\n', ', ').split(', ')
          request['customer']['address']['line1'] = addressSplit[0]
          request['customer']['address']['line2'] = addressSplit[1]
          request['customer']['address']['line3'] = addressSplit[2]
          break
        case 'city':
          request['customer']['address']['city'] = value
          break
        case 'state': case 'province': case 'statecode': case 'region':
          request['customer']['address']['state'] = value
          break
        case 'zip': case 'postcode':
          request['customer']['address']['post_code'] = value
          break
        case 'message': case 'request': case 'text':
          request['request']['message'] = value
          break
        default:
          console.log('Form field node [key] not recognized as useful for Entrata sendLeads: ' + key)
      }
    }

    return request
  }

  // Send Leads to Entrata via AJAX, using the sendLeads API endpoint
  sendLeads (_data) {
    const utility = new ECSLeadUtils()
    utility.runAttributionAjax('entrata', 'sendlead', _data)
  }

  // Entrata-specific function that runs on form submit event
  onFormSubmit (_data, _lead) {
    const sendLeadsData = this.buildSendLeadsData(_data, _lead.leadParam.value)
    this.sendLeads(sendLeadsData)
  }
}
